
<div class="gridheight mat-elevation-z8 viewport">  
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onOpenPM(row, 'Edit')">
              <mat-icon matListIcon>edit</mat-icon>
              <span matLine>Edit</span>
            </button>
            @if(controlPermissions.duplicateTotePriceMatrix){
              <button mat-menu-item (click)="onOpenPM(row, 'Duplicate')">
                <mat-icon matListIcon>content_copy</mat-icon>
                <span matLine>Duplicate</span>
              </button>
            }
            @if(controlPermissions.deleteTotePriceMatrix){
              <button mat-menu-item (click)="onDeletePM(row.Id)" style="color: red;">
                <mat-icon matListIcon color="warn">delete</mat-icon>
                <span matLine>Delete</span>
              </button>
            }
          </mat-menu>
        </td>
    </ng-container>

    @for (col of dynamicColumns(); track col.columnDef) {
      <ng-container [matColumnDef]="col.columnDef">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [innerHTML]="col.header"> </th>
        <td mat-cell *matCellDef="let element"> 
          {{ formatCell(element[col.columnDef], col.columnDef) }} 
        </td>
      </ng-container>
    }

    <!-- Header and Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns();"
        class="hover:bg-gray-100 cursor-pointer transition-colors duration-150"></tr>

    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns().length"
        style="color: red;text-align: center;font-weight: 500;">
        No Tote data available.
      </td>
    </tr>
  </table>
</div>
